import React from "react";
import Grid from "../Grid/Grid";

function AddParameterModal({
  visible,
  setVisible,
  setParameter,
  currentCategory,
}) {
  const handleAddParameterSubmit = (event) => {
    event.preventDefault();

    const name = event.target[0]?.value;

    const newParameter = {
      id: name,
      category: currentCategory?.category,
      categoryTitle: currentCategory?.categoryTitle,
      from: currentCategory?.category === "income" ? name : "budget",
      to: currentCategory?.category === "income" ? "budget" : name,
      value: null,
    };
    setParameter((prevItems) => [...prevItems, newParameter]);
    setVisible(false);

    const form = document.getElementById("addParameter");
    form.reset();
  };

  return (
    <form onSubmit={handleAddParameterSubmit} id="addParameter">
      <div
        className={`modal fade ${visible ? "show" : ""}`}
        id="addParameterModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden={!visible}
        data-keyboard
        data-backdrop={visible}
        style={{ display: visible ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content search-modal">
            <Grid>
              <h3 className="text-dark modal-header col-12">Wert hinzufügen</h3>

              <div className="form-group col-12">
                <label className="text-dark" for="formName">
                  Name
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="formName"
                    required
                  />
                </div>
              </div>
            </Grid>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-toggle="modal"
                data-target="#addParameterModal"
                onClick={() => setVisible(false)}
              >
                Abbrechen
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-search-custom dismiss-active-or-focus"
                data-toggle="modal"
                data-target="#addParameterModal"
                onClick={() => setVisible(false)}
              >
                Hinzufügen
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default AddParameterModal;
